import { useMemo } from "react"
import { Stack, IconButton } from "@mui/material"
import { useTranslation } from "react-i18next"
import type { ReactNode } from "react"

import PlotHelpTooltip from "widgets/plots/PlotHelpTooltip"
import SectionTitle from "./SectionTitle"

interface SectionHeaderProps {
  id?: string
  titleKey: string
  tooltipContent?: ReactNode[]
  actionPermission?: boolean
  isDoingAction?: boolean
  handleAction?: () => void
  actionIcon?: ReactNode
  actionLabelKey?: string
}

const SectionHeader = ({
  id,
  titleKey,
  tooltipContent,
  actionPermission = true,
  isDoingAction = false,
  handleAction,
  actionIcon,
  actionLabelKey,
}: SectionHeaderProps) => {
  const { t } = useTranslation()
  const hasAction = useMemo(() => handleAction && actionIcon, [handleAction, actionIcon])

  return (
    <Stack
      id={id}
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      borderBottom={1}
      borderColor={(theme) => theme.palette.neutral[400]}
      px={2.5}
      py={1.5}
      height={"45px"}
    >
      <SectionTitle title={t(titleKey)}>
        {tooltipContent && <PlotHelpTooltip content={tooltipContent} />}
      </SectionTitle>
      {actionPermission && hasAction && !isDoingAction && (
        <IconButton
          size="small"
          color="primary"
          onClick={handleAction}
          aria-label={actionLabelKey ? t(actionLabelKey) : undefined}
        >
          {actionIcon}
        </IconButton>
      )}
    </Stack>
  )
}

export default SectionHeader
